module.exports = __webpack_public_path__ + "img/20201015.0d1700bd.jpg";